export default "__VITE_ASSET__CZYWE0Wq__"